import { ArrowLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';
import cn from 'classnames';

import Button from 'components/form/Button.component';
import S from 'constants/string.const';
import { useTranslation } from 'providers/GILT.provider';
import { useTheme } from 'providers/Theme.provider';

import { BUILDER_STEPS } from '../consultationForms.const';

import CN from './FormBuilderBreadcrumb.module.scss';

export const FormBuilderBreadcrumb = ({ onRequestClose, currentStep, onBack, isStepperVisible }) => {
  const { t } = useTranslation();
  const { isDarkMode } = useTheme();
  const currentStepLabel = BUILDER_STEPS.find((s) => s.number === currentStep)?.label;

  return (
    <div
      data-bem="FormBuilderBreadcrumb"
      className={cn(CN.stickyWrap, {
        [CN.darkMode]: isDarkMode,
      })}
    >
      <div className={CN.desktopBreadcrumb}>
        <div className={CN.innerRow}>
          <div className={CN.breadcrumbContent}>
            <button type="button" data-testid="FormBuilderBreadcrumb__allForms" className={CN.link} onClick={onRequestClose}>
              {t('consultationForms.builder.breadcrumb.allForms')}
            </button>
            <span className={CN.separator} aria-hidden>
              {S.gt}
            </span>
            <span className={CN.current}>{t('consultationForms.builder.breadcrumb.formBuilder')}</span>
          </div>
          <Button
            variant="empty"
            rounded
            tag="FormBuilderBreadcrumb__closeButton"
            data-testid="FormBuilderBreadcrumb__closeDesktop"
            className={CN.closeButton}
            onClick={onRequestClose}
            aria-label={t('common.buttons.close')}
          >
            <XMarkIcon className={CN.navIcon} />
          </Button>
        </div>
      </div>

      <div className={CN.mobileNav}>
        <Button
          variant="empty"
          tag="FormBuilderBreadcrumb__backButton"
          data-testid="FormBuilderBreadcrumb__backMobile"
          className={CN.mobileNavBack}
          onClick={onBack}
          aria-label={t('common.buttons.back')}
        >
          <ArrowLeftIcon className={CN.navIcon} />
        </Button>
        {currentStepLabel && !isStepperVisible && <span className={CN.mobileNavTitle}>{t(currentStepLabel)}</span>}
        <Button
          variant="empty"
          tag="FormBuilderBreadcrumb__closeButton"
          data-testid="FormBuilderBreadcrumb__closeMobile"
          className={CN.mobileNavClose}
          onClick={onRequestClose}
          aria-label={t('common.buttons.close')}
        >
          <XMarkIcon className={CN.navIcon} />
        </Button>
      </div>

      <div className={CN.fullWidthSeparator} aria-hidden />
    </div>
  );
};
